<div class="container">
  <div class="ranking_title mt-5 mb-3">پیامک های آرشیو شده</div>
  <div class="clearfix"></div>
  <ng-container *ngFor="let reminder of reminders">
    <div>
      <div class="reminder_message" *ngIf="reminder.archive">
        <div class="reminder_date_and_time">
          {{reminder.jalali_send_date}}
        </div>
        <div class="flex-f">
          <div class="reminder_message_content">
            {{reminder.content}}
          </div>
        </div>
      </div><!-- .reminder_message -->
    </div>
  </ng-container>
</div>
<app-footer></app-footer>
